// Routes/Views del cockpit clínico — MEDOS-16.

import { AgendaView } from './components/AgendaView';
import { ClinicalHomeView } from './components/HomeView';
import { PatientsView } from './components/PatientsView';

export function ClinicalHomePage() {
  return (
    <div className="p-4">
      <ClinicalHomeView />
    </div>
  );
}

export function ClinicalAgendaView() {
  return (
    <div className="space-y-4 p-4">
      <div>
        <h1 className="text-xl font-semibold text-foreground">Mi agenda</h1>
        <p className="text-sm text-muted-foreground">
          Citas programadas hoy y los próximos 7 días.
        </p>
      </div>
      <AgendaView />
    </div>
  );
}

export function ClinicalPatientsView() {
  return (
    <div className="space-y-4 p-4">
      <div>
        <h1 className="text-xl font-semibold text-foreground">Pacientes</h1>
        <p className="text-sm text-muted-foreground">
          Busca por nombre o número de expediente. Click en cualquier paciente para abrir su expediente.
        </p>
      </div>
      <PatientsView />
    </div>
  );
}
